// reducer.js
import { GET_ALL_CATEGORY_ERROR, GET_ALL_CATEGORY_SUCCESS, GET_ALL_COUNTRIES_ERROR, GET_ALL_COUNTRIES_SUCCESS, GET_ALL_SERVICES_SUCCESS, GET_ALL_SERVICES_ERROR, UPDATE_SERVICES_ERROR, UPDATE_SERVICES_SUCCCESS, CHANGE_STATUS_SERVICES_ERROR, CHANGE_STATUS_SERVICES_SUCCCESS, CREATE_SERVICES_ERROR, CREATE_SERVICES_SUCCCESS, DELETE_SERVICES_SUCCESS, DELETE_SERVICES_ERROR, GET_ALL_PRODUCTS_ERROR, GET_ALL_PRODUCTS_SUCCESS, GET_POLICIES_ERROR, GET_POLICIES_SUCCESS, GET_ALL_COUPONS_SUCCESS, GET_ALL_COUPONS_ERROR, CREATE_COUPONS_ERROR, CREATE_COUPONS_SUCCESS, UPDATE_COUPONS_SUCCESS, UPDATE_COUPONS_ERROR, CHANGE_STATUS_COUPONS_ERROR, CHANGE_STATUS_COUPONS_SUCCESS, GET_CATEGORY_FOR_ALL_ERROR, GET_CATEGORY_FOR_ALL_SUCCESS } from '../actionTypes';

export const saleInitialState = {
  data: null,
  error: "",
  category: [],
  services: [],
  countries: [],
  products: [],
  policies: [],
  coupons: [],
  message: '',
};

export default (state = saleInitialState, action) => {
  switch (action.type) {
    case GET_ALL_CATEGORY_SUCCESS:
      return {
        ...state,
        category: action.payload,
        error: null,
      };
    case GET_ALL_CATEGORY_ERROR:
      return {
        ...state,
        category: [],
        error: action.payload,
      };
    case GET_ALL_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
        error: null,
      };
    case GET_ALL_SERVICES_ERROR:
      return {
        ...state,
        services: [],
        error: action.payload,
      };
    case CREATE_SERVICES_SUCCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case CREATE_SERVICES_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case UPDATE_SERVICES_SUCCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case UPDATE_SERVICES_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case DELETE_SERVICES_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case DELETE_SERVICES_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case CHANGE_STATUS_SERVICES_SUCCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case CHANGE_STATUS_SERVICES_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case GET_ALL_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload,
        error: null,
      };
    case GET_ALL_COUNTRIES_ERROR:
      return {
        ...state,
        countries: [],
        error: action.payload,
      };
    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload,
        error: null,
      };
    case GET_ALL_PRODUCTS_ERROR:
      return {
        ...state,
        products: [],
        error: action.payload,
      };
    case GET_POLICIES_SUCCESS:
      return {
        ...state,
        policies: action.payload,
        error: null,
      };
    case GET_POLICIES_ERROR:
      return {
        ...state,
        policies: [],
        error: action.payload,
      };
      case GET_ALL_COUPONS_SUCCESS:
        return {
          ...state,
          coupons: action.payload,
          error: null,
        };
      case GET_ALL_COUPONS_ERROR:
        return {
          ...state,
          coupons: null,
          error: action.payload,
        };
      case CREATE_COUPONS_SUCCESS:
        return {
          ...state,
          message: action.payload,
          error: null,
        };
      case CREATE_COUPONS_ERROR:
        return {
          ...state,
          message: null,
          error: action.payload,
        };
        case UPDATE_COUPONS_SUCCESS:
          return {
            ...state,
            message: action.payload,
            error: null,
          };
        case UPDATE_COUPONS_ERROR:
          return {
            ...state,
            message: null,
            error: action.payload,
          };
        case CHANGE_STATUS_COUPONS_SUCCESS:
          return {
            ...state,
            message: action.payload,
            error: null,
          };
        case CHANGE_STATUS_COUPONS_ERROR:
          return {
            ...state,
            message: null,
            error: action.payload,
          };
        case GET_CATEGORY_FOR_ALL_SUCCESS:
          return {
            ...state,
            category: action.payload,
            error: null,
          };
        case GET_CATEGORY_FOR_ALL_ERROR:
          return {
            ...state,
            message: null,
            error: action.payload,
          };
    default:
      return state;
  }
};

